import { Directive } from '@angular/core';

@Directive({
  selector: '[etAtomsMenuTrigger]',
})
export class MenuTriggerDirective {}
